import React from 'react';
import { translate } from 'react-i18next';

import Modal from 'components/Modal';

// This component will listen for events on specific stores, and it will respond with a simple confirmation modal.
//    To listen for additional events, add the store and the event key to the array above
class ConfirmationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      display: false,
      payload: {}
    }

    this.cancel = this.cancel.bind(this);
    this.continue = this.continue.bind(this);
    this.dispatchCallback = this.dispatchCallback.bind(this);
  }

  componentDidMount() {
    MakeShiftEmployeeDispatcher.register(
      this.dispatchCallback,
    );
  }

  cancel() {
    this.setState({ display: false, payload: {} });
  }

  continue() {
    if (this.state.payload.hasOwnProperty('confirmation_cb') && typeof this.state.payload.confirmation_cb == 'function' ) {
      this.state.payload.confirmation_cb( this.state.payload );
    }
    this.setState({ display: false, payload: {} });
  }

  dispatchCallback(payload) {
    let actionType = payload.actionType;
    let ActionTypes = appConstants.ActionTypes;

    switch (actionType) {
      case ActionTypes.CONFIRM_ACTION:
        this.setState({ display: true, payload: payload });
      break;
    }
  }

  render() {
    let modal = null;

    if (this.state.display) {
      const body = ( <span>{this.state.payload.body}</span> );
      const footer = (
        <div className="btn-group pull--right">
          <button className="button" onClick={this.cancel}>{this.props.t('ConfirmationModal.cancel')}</button>
          <button className="button button--recommended" onClick={this.continue}>{this.props.t('ConfirmationModal.continue')}</button>
        </div>
      );

      modal = (
        <Modal
          header={this.state.payload.header}
          body={body}
          footer={footer}
        />
      );
    }

    return modal;
  }
}

export default translate()(ConfirmationModal);
